import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    IBaseController,
    Inject, ModelEvents
} from '@denishussar/html5-game-engine';
import {Rectangle, Texture} from 'pixi.js';
import {IPictureData} from '../../../Services/CloudDB/Contract';
import {ButtonController, IButtonControllerOptions} from '../../../Common/ButtonController';
import {getSpriteFromUrl} from '../../../Common/getSpriteFromUrl';
import {createGreyTexture} from '../../../Common/Utils';
import {LocalizationContents} from '../../../LocalizationContents';
import {GameLogic} from '../../../Logic/GameLogic';
import {AlbumsLibrary} from '../../../Models/AlbumsLibrary';
import {GameModel} from '../../../Models/GameModel';
import {ScrollBarController} from '../../UI/ScrollBarController';
import {ScrollPaneController} from '../../UI/ScrollPaneController';
import {CatalogIconController, ICatalogIconControllerOptions} from './CatalogIconController';
import {BlueButtonTextStyle, GreenButtonTextStyle} from '../../../Constants/TextStyles';
import * as filter from '@pixi/filter-glow';
import gsap from "gsap";
import {GameEvent} from "../../../Constants/GameEvent";

export interface ICatalogFolderControllerOptions {
    onClick: (albumId: string) => void;
}

export interface IPictureTexture {
    picture: IPictureData;
    texture: PIXI.Texture | undefined;
}

export class CatalogFolderController extends AnimationBaseController {
    $model: GameModel;

    protected static OPEN = 'open';
    protected static STARTED = 'started';
    protected static READY = 'ready';

    protected currenAlbum: string;
    protected scrollPane: ScrollPaneController;
    protected scrollBar: ScrollBarController;

    protected scrollPaneRectMax = new Rectangle(-663, -533 + 550, 1326, 1063 - 10);
    protected scrollPaneRectMin = new Rectangle(-663, -408 + 400, 1326, 1063 - 10 - 125);

    private inScroll: boolean = false;

    public constructor(
        @Inject protected _options: ICatalogFolderControllerOptions,
        @Inject protected _gameLogic: GameLogic,
        @Inject private modelEvents: ModelEvents,
        @Inject private model: GameModel,
    ) {
        super('CatalogFolderController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            childControllers: {
                // btn_open: {
                //     controller: ButtonController,
                //     instanceName: 'btn_tab_1',
                //     options: <IButtonControllerOptions>{
                //         label: LocalizationContents.getText('Unlocked'),
                //         onClick: (status: boolean) => {
                //             this.selectAlbum(AlbumsLibrary.MY_COLLECTION, CatalogFolderController.OPEN);
                //         }
                //     }
                // },
                // btn_started: {
                //     controller: ButtonController,
                //     instanceName: 'btn_tab_2',
                //     options: <IButtonControllerOptions>{
                //         label: LocalizationContents.getText('In progress'),
                //         onClick: (status: boolean) => {
                //             this.selectAlbum(AlbumsLibrary.MY_COLLECTION, CatalogFolderController.STARTED);
                //         }
                //     }
                // },
                // btn_ready: {
                //     controller: ButtonController,
                //     instanceName: 'btn_tab_3',
                //     options: <IButtonControllerOptions>{
                //         label: LocalizationContents.getText('Finished'),
                //         onClick: (status: boolean) => {
                //             this.selectAlbum(AlbumsLibrary.MY_COLLECTION, CatalogFolderController.READY);
                //         }
                //     }
                // }
            },
        };
    }

    protected onInitialize() {
        this.scrollBar = this.addChildController({
            instanceName: 'scroll_bar_journal',
            controller: ScrollBarController,
            options: {
                onused: (value: number) => {
                    this.mediator.onusedScrollBar(value);
                }
            }
        }, 'ScrollBarController') as ScrollBarController;
        this.startTimer();

        if (!this.currenAlbum) {
            this.currenAlbum = AlbumsLibrary.MY_COLLECTION;
            // setTimeout(() => {
            //     this.selectAlbum(AlbumsLibrary.MY_COLLECTION, CatalogFolderController.READY);
            // }, 3000)
        }

        // setTimeout(() => {
        //     this.selectAlbum(AlbumsLibrary.MY_COLLECTION, CatalogFolderController.READY)
        // }, 1000);

        this.modelEvents.on(this.model, GameEvent.scroll, this.startTimer, this);
    }

    protected onDestroy() {
        super.onDestroy();
        this.modelEvents.off(this.model, GameEvent.scroll, this.startTimer);
    }

    private currentGlow?: filter.GlowFilter[];
    private currentGlowTarget?: IBaseController;
    private glowTimerID?: any;
    protected firstIconOnPage?: string;

    protected startTimer(): void {
        const lifeTime = Number(localStorage.getItem('lifetime') ?? 0);

        if (this.currentGlow) {
            for (let filt of this.currentGlow) {
                gsap.killTweensOf(filt);
            }
            this.currentGlow = undefined;
        }
        if (this.currentGlowTarget) {
            this.currentGlowTarget.display.filters = [];
            this.currentGlowTarget = undefined;
        }
        if (this.glowTimerID) clearTimeout(this.glowTimerID);

        if (lifeTime > 60) return;

        this.glowTimerID = setTimeout(() => {
            if (!this.firstIconOnPage) return;

            const item = this.$childControllers.get(this.firstIconOnPage);
            if (!item) return;

            this.currentGlowTarget = item;
            this.currentGlow = [
                new filter.GlowFilter(5, 0, 0, 0xffc200),
                new filter.GlowFilter(75, 0, 0, 0xffc200),
            ]

            item.display.filters = [
                ...this.currentGlow
            ];

            for (let filt of this.currentGlow) {
                gsap.killTweensOf(filt);
            }

            gsap.to(this.currentGlow[0], {
                duration: 1,
                outerStrength: 10,
                yoyo: true,
                yoyoEase: true,
                repeat: -1,
            });
            gsap.to(this.currentGlow[1], {
                duration: .5,
                innerStrength: 5,
                yoyo: true,
                yoyoEase: true,
                repeat: -1,
            });
        }, 10000);
    }

    public inSelecting = false;
    public async selectAlbum(id: string, tab = CatalogFolderController.OPEN): Promise<void> {
        if (this.inSelecting) return;
        this.inSelecting = true;
        this.startTimer();
        this.currenAlbum = id;

        const arr = this.$model.albumLibrary.getAllAlbums();
        if (!arr || arr.length === 0) {
            return;
        }

        if (id === AlbumsLibrary.GLORIA) {
            this.gotoAndStop('Gloria');
            this.setTextByQuery('history_gloria.txt_gloria', LocalizationContents.getText('Chapter1'));
            return;
        }

        let pictures: IPictureData[];
        if (id === AlbumsLibrary.MY_COLLECTION) {
            this.gotoAndStop('my_collection');

            this.createScrollPane();

            this.scrollPane.setSize(this.scrollPaneRectMin.width, this.scrollPaneRectMin.height);
            this.scrollPane.display.y = this.scrollPaneRectMin.y;

            const btn_open = this.$childControllers.get('btn_open') as ButtonController;
            const btn_started = this.$childControllers.get('btn_started') as ButtonController;
            const btn_ready = this.$childControllers.get('btn_ready') as ButtonController;

            switch (tab) {
                case CatalogFolderController.OPEN:
                    btn_open.toggle = true;
                    btn_started.toggle = false;
                    btn_ready.toggle = false;

                    this.setTextStyleByQuery('btn_tab_1.label', BlueButtonTextStyle);
                    this.setTextStyleByQuery('btn_tab_2.label', GreenButtonTextStyle);
                    this.setTextStyleByQuery('btn_tab_3.label', GreenButtonTextStyle);

                    break;
                case CatalogFolderController.STARTED:
                    btn_open.toggle = false;
                    btn_started.toggle = true;
                    btn_ready.toggle = false;

                    this.setTextStyleByQuery('btn_tab_1.label', GreenButtonTextStyle);
                    this.setTextStyleByQuery('btn_tab_2.label', BlueButtonTextStyle);
                    this.setTextStyleByQuery('btn_tab_3.label', GreenButtonTextStyle);

                    break;
                case CatalogFolderController.READY:
                    btn_open.toggle = false;
                    btn_started.toggle = false;
                    btn_ready.toggle = true;

                    this.setTextStyleByQuery('btn_tab_1.label', GreenButtonTextStyle);
                    this.setTextStyleByQuery('btn_tab_2.label', GreenButtonTextStyle);
                    this.setTextStyleByQuery('btn_tab_3.label', BlueButtonTextStyle);

                    break;
            }

            pictures = this.selectTab(tab);
        } else {
            this.gotoAndStop('journals');

            this.createScrollPane();

            this.scrollPane.setSize(this.scrollPaneRectMax.width, this.scrollPaneRectMax.height);
            this.scrollPane.display.y = this.scrollPaneRectMax.y;

            const album = this.$model.albumLibrary.getAlbumData(id);
            if (!album) {
                return;
            }
            pictures = [];
            album.pictures.forEach((id) => {
                const picture = this.$model.albumLibrary.getPictureData(id);
                if (picture) {
                    pictures.push(picture);
                }
            });
        }

        await this.prepareTextures(pictures)
            .then((pictures) => {
                return Promise.resolve(this.sortPictures(pictures));
            })
            .then((pictures) => {
                this.firstIconOnPage = pictures[0].picture.id;
                return this.createScrollPaneContent(pictures);
            })
            .then((content) => {
                this.scrollPane.content = content;
                this.scrollBar.resetSliderPosition();

                // HACK
                this.scrollBar.visible = this.scrollPane.content.height > 1024;
                return Promise.resolve();
            })

        this.inSelecting = false;
    }

    protected selectTab(id: string): IPictureData[] {
        // all albums screaning
        const albums = this.$model.albumLibrary.getAllAlbums();
        const pictures: IPictureData[] = [];

        for (let i = 0; i < albums.length; i++) {
            const album = albums[i];

            if (album.id === AlbumsLibrary.MY_COLLECTION) {
                continue;
            }

            for (let j = 0; j < album.pictures.length; j++) {
                const picture = this.$model.albumLibrary.getPictureData(album.pictures[j]);
                const save = this._gameLogic.getSave(picture.id);

                if (album.id === AlbumsLibrary.GLORIA || (save && save.src)) {
                    const percent = save ? this._gameLogic.getPercentageProgress(save) : 0;
                    switch (id) {
                        case CatalogFolderController.READY:
                            if (percent === 100) {
                                pictures.push(picture);
                            }
                            break;
                        case CatalogFolderController.OPEN:
                            if (percent === 0) {
                                pictures.push(picture);
                            }
                            break;
                        case CatalogFolderController.STARTED:
                            if (percent > 0 && percent < 100) {
                                pictures.push(picture);
                            }
                            break;
                    }
                }
            }
        }
        return pictures;
    }

    protected mediator = {
        onusedScrollBar: (y: number) => {
            if (!this.scrollPane || !this.scrollPane) {
                return;
            }
            const bg = this.scrollBar.background;
            const sl = this.scrollBar.slider;

            // TODO - hack
            y = this.scrollPane.content.height / (-1 * bg.height / (sl.y + bg.height / 2 / 2.6));
            this.scrollPane.setContentPosition(y);
        },
        onusedScrollPanel: (y: number) => {
            if (!this.scrollBar) {
                return;
            }
            const bg = this.scrollBar.background;
            // TODO - hack
            this.scrollBar.setSliderPosition(-1 * bg.height / (this.scrollPane.content.height / y) * 2.6 - bg.height / 2);
        }
    };

    protected prepareTextures(pictures: IPictureData[]): Promise<IPictureTexture[]> {
        const promises: Promise<IPictureTexture>[] = [];
        for (let i = 0; i < pictures.length; i++) {
            const picture = pictures[i];
            const save = this._gameLogic.getSave(picture.id);
            let promise: Promise<IPictureTexture>;
            if (save && save.src) {
                promise = new Promise((resolve) => {
                    const texture = PIXI.Texture.from(save.src);

                    const timeout = 100;
                    const size = 1;
                    let timerId = setTimeout(function tick() {
                        if (texture.width > size && texture.height > size) {
                            texture.baseTexture.scaleMode = PIXI.SCALE_MODES.NEAREST;
                            resolve({picture, texture});
                        } else {
                            timerId = setTimeout(tick, timeout);
                        }
                    }, timeout);
                });
                promises.push(promise);
            } else {
                promise = getSpriteFromUrl('assets/' + picture.src, `icon${picture.id}`)
                    .then((res) => {
                        const {sprite, cached} = res;
                        let texture: PIXI.Texture | undefined = sprite.texture;
                        // console.log(texture)
                        if (sprite.texture) {
                            texture = createGreyTexture(sprite.texture);
                            texture.baseTexture.scaleMode = PIXI.SCALE_MODES.NEAREST;
                        }

                        return Promise.resolve({picture, texture});
                    });

                promises.push(promise);
            }
        }

        return Promise.all(promises);
    }

    protected sortPictures(pictures: IPictureTexture[]): Promise<IPictureTexture[]> {
        pictures.sort((a1, a2) => {
            const data1 = a1.picture as IPictureData;
            const data2 = a2.picture as IPictureData;

            const save1 = this._gameLogic.getSave(data1.id);
            const save2 = this._gameLogic.getSave(data2.id);

            if (save1 && save2) {
                const p1 = this._gameLogic.getPercentageProgress(save1);
                const p2 = this._gameLogic.getPercentageProgress(save2);
                return p1 > p2 ? -1 : 1;
            } else if (save1 && !save2) {
                return -1;
            } else if (!save1 && save2) {
                return 1;
            } else {
                const texture1 = a1.texture as Texture;
                const texture2 = a2.texture as Texture;
                return texture1.width > texture2.width ? 1 : -1;
            }
        });
        return Promise.resolve(pictures);
    }

    protected createScrollPane(): void {
        if (this.scrollPane) {
            this.removeChildController(this.scrollPane);
        }

        this.scrollPane = this.addChildController({
            controller: ScrollPaneController,
            options: {
                scrollBar: this.scrollBar,
                onused: (value: number) => {
                    this.mediator.onusedScrollPanel(value);
                }
            }
        }, 'scrollPane') as ScrollPaneController;

        const container = this.getDisplayObjectByQuery('scrollList')[0] as PIXI.Container;
        while (container.children.length > 0) {
            container.removeChildAt(0);
        }

        container.addChild(this.scrollPane.display);
    }

    protected async createScrollPaneContent(pictures: IPictureTexture[]): Promise<PIXI.Container> {
        const content = new PIXI.Container();

        for (let i = 0; i < pictures.length; i++) {
            const picture = pictures[i].picture as IPictureData;
            const texture = pictures[i].texture as Texture;

            let icon = this.$childControllers.get(picture.id);
            if (icon) {
                this.removeChildController(icon);
            }

            icon = await this.addChildControllerAsync({
                model: this.$model,
                controller: CatalogIconController,
                options: <ICatalogIconControllerOptions>{
                    album: this.$model.albumLibrary.getAlbumData(this.currenAlbum),
                    picture: picture,
                    texture: texture,
                    onClick: () => {
                        if (this.scrollPane.isInScroll) return;
                        this._options.onClick(picture.id);
                    }
                }
            }, false, picture.id);
            const deltaX = Math.floor(i % 3);
            const deltaY = Math.floor(i / 3);
            // console.log(icon)


            if (icon.display) {
                icon.display.x = icon.display.width / 2 + deltaX * icon.display.width + 20 * (deltaX);
                icon.display.y = icon.display.height / 2 + deltaY * icon.display.height + 30 * (deltaY);

                content.addChild(icon.display);
                icon.display.alpha = 255;
            }
        }

        // console.log(content)
        return Promise.resolve(content);
    }
}
